import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "antd";
// T2/100A145: HelpModule ya no se usa aquí (ícono "?" retirado).
// import HelpModule from "./help";
import BadgeModule from "./BadgeModule";

const { Text } = Typography;

export default function RenderModule({ module, onSubmenu }) {
  if (!module.disabled) {
    if (module.submenuKey) {
      return (
        <div
          className="animate__animated animate__fadeIn block-module"
          title={module.help || undefined}
          onClick={() => onSubmenu && onSubmenu(module.submenuKey)}
          style={{ cursor: 'pointer' }}
        >
          <BadgeModule {...module} />
          <div className="module-icon-wrap">
            {typeof module.img === "string"
              ? <img src={module.img} className="module-icon" style={{width:20,height:20}} />
              : module.img}
          </div>
          <Text style={{
            fontSize: 12, fontWeight: 500, textAlign: 'center',
            lineHeight: 1.3, color: '#0F1E3C', padding: '0 6px'
          }}>
            {module.name}
          </Text>
          {/* T2/100A145: el ícono "?" quedaba suelto en la esquina superior izquierda de la página
              (position: absolute y el mosaico sin position: relative). Usuario (2026-10-27): quitarlo.
              La ayuda se conserva como texto al pasar el mouse (title del mosaico). Antes: */}
          {/* {module.help && <HelpModule message={module.help} />} */}
        </div>
      );
    }

    return (
      <Link
        to={module.href}
        className="animate__animated animate__fadeIn block-module"
        title={module.help || undefined}
      >
        <BadgeModule {...module} />
        <div className="module-icon-wrap">
          {typeof module.img === "string"
            ? <img src={module.img} className="module-icon" style={{width:20,height:20}} />
            : module.img}
        </div>
        <Text style={{
          fontSize: 12, fontWeight: 500, textAlign: 'center',
          lineHeight: 1.3, color: '#0F1E3C', padding: '0 6px'
        }}>
          {module.name}
        </Text>
        {/* T2/100A145: ícono "?" retirado (ver arriba). Antes: */}
        {/* {module.help && <HelpModule message={module.help} />} */}
      </Link>
    );
  }
  return null;
}
